import { CCard, CCardBody, CCol, CCardHeader, CRow } from '@coreui/react'
import {
    CChartBar,
    CChartDoughnut,
    CChartLine,
    CChartPie,
    CChartPolarArea,
    CChartRadar,
} from '@coreui/react-chartjs'
import { DocsCallout } from 'src/components';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Flex, Input, Tabs, Upload, Select, Spin, Checkbox, Modal } from 'antd';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { apiUrls } from '../../apiUrls.js';
import Program from "../../components/Program.js";
import { useNavigate } from 'react-router-dom';
import { UnlockOutlined, LockOutlined, EditOutlined, SafetyCertificateOutlined, PoweroffOutlined } from '@ant-design/icons';
import HideSidebarInMobileMode from "../../components/HideSidebarInMobileMode.js";
import { getMemberAge } from '../../utils/memberAge.js';
const baseURL = apiUrls.baseURL;

const Trials = () => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [loadingChangeToOfficial, setLoadingChangeToOfficial] = useState(false);
    const [loadingChangeToGuest, setLoadingChangeToGuest] = useState(false);
    const [memberData, setMemberData] = useState({});
    const [count, setCount] = useState(0);
    const [isShowChangeToOfficialModalVisible, setIsShowChangeToOfficialModalVisible] = useState(false);
    const [isShowChangeToGuestModalVisible, setIsShowChangeToGuestModalVisible] = useState(false);
    const [filter, setFilter] = useState({ skip: 0, limit: 20 });
    const [loadingCertificateReport, setLoadingCertificateReport] = useState(false);
    const [loadingJoinProgramReport, setLoadingJoinProgramReport] = useState(false);
    const [loadingFinancialReport, setLoadingFinancialReport] = useState(false);
    const navigate = useNavigate();

    const columns = [
        {
            title: 'ردیف',
            dataIndex: 'index',
            key: 'index',
            responsive: ['xl', 'lg'],
            width: 50,
            render: (_, record, index) => (
                <>{index + 1}</>
            ),
        },
        {
            title: 'نام',
            key: 'firstName',
            dataIndex: 'firstName',
            width: 100,
            responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
            render: (text, record) => (
                <div>{record.firstName} <br /> {record.lastName}</div>
            ),
        },
        {
            title: 'تلفن/کدملی',
            key: 'phoneNumber',
            dataIndex: 'phoneNumber',
            width: 10,
            responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
            render: (text, record) => (
                <div>{record.phoneNumber} <br /> {record.nationalCode}</div>
            ),
        },
        {
            title: 'تصویر',
            key: 'profilePhotoUrl',
            dataIndex: 'profilePhotoUrl',
            width: 100,
            responsive: ['xl', 'lg', 'md'],
            render: (text, record) => (
                record.profilePhotoUrl !== null ? <a rel="noreferrer" href={record.profilePhotoUrl} target='_blank'>
                    <img style={{ borderRadius: 50 }} width={100} height={100} src={record.profilePhotoUrl}>
                    </img></a> : 'بدون تصویر'
            ),
        },
        {
            title: 'تبدیل به رسمی',
            key: 'id',
            dataIndex: 'id',
            width: 100,
            responsive: ['xl', 'lg', 'md'],
            render: (text, record) => (
                <SafetyCertificateOutlined onClick={() => {
                    setIsShowChangeToOfficialModalVisible(true)
                    setMemberData({ memberName: record.firstName + " " + record.lastName, memberId: record.id })
                }} style={{ color: 'green', fontSize: 30 }} />
            ),
        },
        {
            title: 'تبدیل به مهمان',
            key: 'id',
            dataIndex: 'id',
            width: 100,
            responsive: ['xl', 'lg', 'md'],
            render: (text, record) => (
                <PoweroffOutlined onClick={() => {
                    setIsShowChangeToGuestModalVisible(true)
                    setMemberData({ memberName: record.firstName + " " + record.lastName, memberId: record.id })
                }} style={{ color: 'red', fontSize: 30 }} />
            ),
        },
        {
            title: 'جزئیات',
            key: 'id',
            dataIndex: 'id',
            width: 100,
            responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
            render: (text, record) => (
                <a rel='noreferrer' href={'/members/trialdetail/' + record.id}><EditOutlined style={{ color: 'blue', fontSize: 30 }} /></a>
            ),
        },
    ];

    useEffect(() => {
        if (!loadingMore) setLoading(true);
        fetchData()
    }, [filter])

    useEffect(() => {
        const loadNextPage = () => {
            const isNearBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 200;
            const hasMore = data.length < count;

            if (isNearBottom && hasMore && !loading && !loadingMore) {
                setLoadingMore(true);
                setFilter((current) => ({ ...current, skip: current.skip + 1 }));
            }
        };

        window.addEventListener('scroll', loadNextPage);
        loadNextPage();
        return () => window.removeEventListener('scroll', loadNextPage);
    }, [data, count, loading, loadingMore, filter.skip]);

    const fetchData = async () => {

        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/user/getTrialMembers?skip=${filter.skip}&limit=${filter.limit}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            var result = response.data.data;
            setCount(result.count)
            setData((current) => filter.skip === 0 ? result.items : [...current, ...result.items]);
            setLoading(false);
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoading(false);
        } finally {
            setLoading(false);
            setLoadingMore(false);
        }
    };

    const refreshTrialMembers = () => {
        setData([]);
        setLoading(true);
        setLoadingMore(false);
        setFilter((current) => ({ ...current, skip: 0 }));
    };

    const changeToOfficial = async () => {
        setLoadingChangeToOfficial(true)
        const token = localStorage.getItem('damavandclub-token')
        try {
            await axios.get(`${baseURL}/user/SetOfficialMember?id=${memberData.memberId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            toast.success("با موفقیت ثبت شد", {
                position: 'bottom-right',
                autoClose: 3000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            refreshTrialMembers()
            setIsShowChangeToOfficialModalVisible(false)
            setLoadingChangeToOfficial(false)
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoadingChangeToOfficial(false);
        } finally {
            setLoadingChangeToOfficial(false);
        }
    };

    const changeToGuest = async () => {
        setLoadingChangeToGuest(true)
        const token = localStorage.getItem('damavandclub-token')
        try {
            await axios.get(`${baseURL}/user/SetGuestMember?id=${memberData.memberId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            toast.success("با موفقیت ثبت شد", {
                position: 'bottom-right',
                autoClose: 3000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            refreshTrialMembers()
            setIsShowChangeToGuestModalVisible(false)
            setLoadingChangeToGuest(false)
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoadingChangeToGuest(false);
        } finally {
            setLoadingChangeToGuest(false);
        }
    };

    const getJoinProgramReport = async () => {

        setLoadingJoinProgramReport(true)
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/user/getTrialMemberJoinProgramReport`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                }, 'responseType': 'blob'
            });
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');

            setLoadingJoinProgramReport(false);
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoadingJoinProgramReport(false);
        } finally {
            setLoadingJoinProgramReport(false);
        }
    };

    const getFinancialReport = async () => {

        setLoadingFinancialReport(true)
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/user/getTrialFinancialReport`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                }, 'responseType': 'blob'
            });
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');

            setLoadingFinancialReport(false);
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoadingFinancialReport(false);
        } finally {
            setLoadingFinancialReport(false);
        }
    };

    const getCertificateReport = async () => {

        setLoadingCertificateReport(true)
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/user/getTrialMembersReport`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                }, 'responseType': 'blob'
            });
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');

            setLoadingCertificateReport(false);
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoadingCertificateReport(false);
        } finally {
            setLoadingCertificateReport(false);
        }
    };

    return (
        <div>
            <HideSidebarInMobileMode />
            <div className="row trial-member-report-actions">
                <Button className="trial-report-button trial-report-certificates" onClick={() => getCertificateReport()} loading={loadingCertificateReport}
                    type="primary"><label>گزارش دورهای گذرانده شده</label></Button>
                <Button className="trial-report-button trial-report-programs" onClick={() => getJoinProgramReport()} loading={loadingJoinProgramReport}
                    type="primary"><label>گزارش شرکت در برنامه ها</label></Button>
                <Button className="trial-report-button trial-report-financial" onClick={() => getFinancialReport()} loading={loadingFinancialReport}
                    type="primary"><label>گزارش مالی</label></Button>
            </div>

            <div className="members-total-count">
                <span>{'\u062a\u0639\u062f\u0627\u062f \u06a9\u0644 \u0627\u0639\u0636\u0627'}</span>
                <strong>{count}</strong>
            </div>
            <div className="member-cards trial-member-cards">
                {data.map((record) => (
                    <article key={record.id} className="member-card">
                        <div className="member-card-header">
                            {record.profilePhotoUrl
                                ? <a href={record.profilePhotoUrl} target="_blank" rel="noreferrer"><img className="member-card-photo" src={record.profilePhotoUrl} alt={`${record.firstName} ${record.lastName}`} /></a>
                                : <div className="member-card-photo member-card-photo-empty">—</div>}
                            <div className="member-card-name"><strong>{record.firstName} {record.lastName}</strong></div>
                        </div>
                        <div className="member-card-details">
                            <span>موبایل: {record.phoneNumber || '—'}</span>
                            <span>کد ملی: {record.nationalCode || '—'}</span>
                            {getMemberAge(record.birthDay || record.birthDate) !== null && <span>سن: {getMemberAge(record.birthDay || record.birthDate)}</span>}
                        </div>
                        <div className="trial-member-card-actions">
                            <Button className="trial-official-button" type="link" icon={<SafetyCertificateOutlined />} onClick={() => {
                                setIsShowChangeToOfficialModalVisible(true);
                                setMemberData({ memberName: record.firstName + ' ' + record.lastName, memberId: record.id });
                            }}>تبدیل به رسمی</Button>
                            <Button type="link" danger icon={<PoweroffOutlined />} onClick={() => {
                                setIsShowChangeToGuestModalVisible(true);
                                setMemberData({ memberName: record.firstName + ' ' + record.lastName, memberId: record.id });
                            }}>تبدیل به مهمان</Button>
                            <Button className="member-card-details-button" type="link" icon={<EditOutlined />} onClick={() => navigate('/members/trialdetail/' + record.id)}>مشاهده پروفایل</Button>
                        </div>
                    </article>
                ))}
                {(loading || loadingMore) && <div className="member-cards-loading"><Spin /></div>}
                {!loading && data.length === 0 && <div className="member-cards-empty">موردی یافت نشد</div>}
            </div>
            {/* Legacy table markup retained below for reference.
            <Table
                size='small'
                style={{
                    textAlign: 'right',
                    marginTop: 10
                }}
                rowClassName={() => 'center'}
                columns={columns}
                bordered={true}
                dataSource={data}
                loading={loading && !loadingMore}
                pagination={false}
                locale={{
                    emptyText: 'موردی یافت نشد',
                }}
            /> */}
            {loadingMore && <div className="members-wallet-load-more"><Spin size="small" /></div>}
            <div className="members-total-count trial-members-total-bottom">
                <span>تعداد کل اعضا</span>
                <strong>{count}</strong>
            </div>

            <Modal
                title={`تبدیل به رسمی ${memberData.memberName}`}
                open={isShowChangeToOfficialModalVisible}
                closable={false}
                okButtonProps={null}
                footer={<div className='row-container'>
                    <Button onClick={() => setIsShowChangeToOfficialModalVisible(false)} style={{ width: '100%' }}>بستن</Button>
                    <Button type="primary" loading={loadingChangeToOfficial}
                        onClick={() => changeToOfficial()}
                        style={{ width: '100%', marginRight: 10, backgroundColor: 'rgb(10, 23, 43)' }}>تایید</Button>
                </div>}
            >
                آیا از رسمی شدن این عضو مطمئن هستید؟
            </Modal>

            <Modal
                title={`تبدیل به مهمان ${memberData.memberName}`}
                open={isShowChangeToGuestModalVisible}
                closable={false}
                okButtonProps={null}
                footer={<div className='row-container'>
                    <Button onClick={() => setIsShowChangeToGuestModalVisible(false)} style={{ width: '100%' }}>بستن</Button>
                    <Button type="primary" loading={loadingChangeToGuest}
                        onClick={() => changeToGuest()}
                        style={{ width: '100%', marginRight: 10, backgroundColor: 'rgb(10, 23, 43)' }}>تایید</Button>
                </div>}
            >
                آیا از مهمان شدن این عضو مطمئن هستید؟
            </Modal>
        </div>
    )
}

export default Trials
